import React, { useState } from "react";
import { Client } from "@/types";
import { ShareWithClientModal } from "@/domains/PostCreator/ShareWithClientModal";
import { ClientEmailsSection } from "./ClientEmailsSection";

interface PortalAccessSectionProps {
  client: Client;
}

export const PortalAccessSection: React.FC<PortalAccessSectionProps> = ({ client }) => {
  const [showClientModal, setShowClientModal] = useState(false);

  return (
    <>
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">Portal Access</h3>
        <p className="text-sm text-gray-600">
          Generate and share a magic link that lets the client sign in to review and approve posts and media.
        </p>

        <div className="border border-gray-200 rounded-lg p-4 mt-4">
          <div className="flex items-start space-x-3">
            <div className="shrink-0">
              <svg
                className="w-6 h-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-gray-900">Client Approval Portal</h4>
              <p className="text-xs text-gray-500 mt-1">
                Send a single-use sign-in link to review and approve posts and media
              </p>
              <button
                onClick={() => setShowClientModal(true)}
                className="mt-3 inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 rounded-md hover:bg-blue-100 transition-colors"
              >
                <svg
                  className="w-4 h-4 mr-1.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                  />
                </svg>
                Generate Link
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4 mt-2">
          <ClientEmailsSection clientId={client.id} />
        </div>
      </div>

      {showClientModal && (
        <ShareWithClientModal
          clientId={client.id}
          clientName={client.clientName}
          isOpen={showClientModal}
          onClose={() => setShowClientModal(false)}
        />
      )}
    </>
  );
};
